import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    GetOperatorId : [],
    loading : false,
    error : null,
};

const getOperatorIdSlice = createSlice({
    name:"GetOperatorId",
    initialState,
    reducers: {
        fetchOperatorIdSuccess: (state,action) => {
            state.loading = false;
            state.GetOperatorId = action.payload;
        },
        fetchOperatorIdFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchOperatorIdSuccess,
    fetchOperatorIdFailure
} = getOperatorIdSlice.actions

export default getOperatorIdSlice.reducer